/** Forces LTR isolation so Arabic RTL does not reorder +code and digits. */
export const toLtrPhone = (value: string): string =>
  value ? `\u2066${value}\u2069` : "";

/** Normalize dial codes to `+965` style for consistent LTR display. */
export const normalizeDialCode = (
  countryCode?: string | null
): string => {
  const raw = String(countryCode || "").trim();
  if (!raw) {
    return "";
  }
  const cleaned = raw.replace(/[^\d+]/g, "");
  if (!cleaned) {
    return "";
  }
  const digits = cleaned.replace(/\+/g, "");
  return digits ? `+${digits}` : "";
};

/**
 * Formats country code + phone for display with LTR isolation.
 * Prevents RTL layouts from showing e.g. "90020055 965+" instead of "+965 90020055".
 */
export const formatPhoneLtr = (
  countryCode?: string | null,
  phone?: string | null
): string => {
  const code = normalizeDialCode(countryCode);
  const number = String(phone || "")
    .replace(/\s+/g, "")
    .trim();
  if (!code && !number) {
    return "-";
  }
  const formatted = [code, number || "-"].filter(Boolean).join(" ").trim();
  return toLtrPhone(formatted);
};
